import { defineStore } from 'pinia';
import { computed, MaybeRefOrGetter, ref, toValue } from 'vue';

import { PiniaStoreId } from '@/constants/pinia';
import { Connection, ConnectionTypes } from '@/models/connections';
import { getConnections } from '@/services/api/connections';

export const useIntegrationsStore = defineStore(PiniaStoreId.Integrations, () => {
  const connections = ref<Connection[]>([]);

  const getCompletedConnections = computed(() =>
    connections.value?.filter((connection) => connection.status === 'complete'),
  );
  const getCompletedConnectionsByType = computed(() => (connectionType: ConnectionTypes) => {
    return getCompletedConnections.value?.filter((connection) => connection.type === connectionType);
  });

  async function fetchConnections({
    marketplace_company_id,
  }: {
    marketplace_company_id: MaybeRefOrGetter<number> | undefined;
  }) {
    const response = await getConnections({ marketplace_company_id: toValue(marketplace_company_id) });

    connections.value = response.results;
  }

  return {
    connections,
    getCompletedConnections,
    getCompletedConnectionsByType,

    fetchConnections,
  };
});

export type IntegrationsState = ReturnType<typeof useIntegrationsStore>;
